<template>
    <div id="content">
        <!-- <div class="left_panel">
            <side-bar /> サイドバーの表示
        </div> -->
        <!-- <div class="main_panel"> -->
            <volunteer-menu /> <!-- コンテンツの表示 -->
        <!-- </div> -->
    </div>
</template>

<script>
//使用するコンポーネントの読み込み
// import SideBar from './SideBar.vue';
import VolunteerMenu from './VolunteerMenu.vue';

export default {
  //名前をつける（あとあと利用することがあれば参照しやすいように？）
//   name: 'main',
  //読み込んだコンポーネントを使えるようにする
  components: {
    // SideBar,
    VolunteerMenu
  },
  setup () {

  }
};
</script>

<style scoped>

</style>